import type { InjectionKey, ComputedRef } from 'vue'
import type { TriScale  } from '@/lib/colorScale'

export type ColorScaleContext = {
  scale: ComputedRef<TriScale>
}

export const ColorScaleKey: InjectionKey<ColorScaleContext> = Symbol('ColorScaleContext')
